module.exports = __webpack_public_path__ + "img/serve1.30046b3a.png";